export const feedConstants = {
  aestrix: '*',
  feedPageTitle: 'Configure Data Feed',
  editDataFeedTitle: 'Edit Data Feed',
  endPointUrlText: 'Your Endpoint URL',
  enabled: 'Enabled',
  disabled: 'Disabled',
  endPointUsernameText: 'Endpoint Username',
  endPointPasswordText: 'Endpoint Password',
  usernameText: 'Username',
  usernamePlaceholder: 'Your username',
  endPointUrlTooltipMessage:
    'The address of your custom endpoint to which we send data; it needs to be HTTPS.',
  usernameToolTipMessage: 'Please input your username here',
  endPointUsenameTooltipMessage:
    'This is the username used to secure your endpoint.',
  endPointPasswordTooltipMessage:
    'This the password for the username above used to secure your endpoint.',
  saveFeedButtonText: 'Save Data Feed',
  acceptablePolicyUrl: 'https://developer.data.nationalhighways.co.uk/terms',
  // privacyNoiceUrl: '/privacy-notice',
  privacyNoiceUrl: 'https://nationalhighways.co.uk/about-us/privacy-notice/',
  prePrivacyNoticeLinkText:
    'Find out why we need this data and how your data is handling in accordance with our ',
  privacyNoticeLinkText: 'Privacy Policy.',
  acceptableUsagePolicyTitle: 'Acceptable Usage Policy',
  preAcceptablePolicyLinkText: 'Please review the ',
  acceptablePolicyLinkText:
    'Highways England Acceptable Use & Operational Policy.',
  promptMsg:
    'You have made changes. If you leave this page without saving, your changes will be lost.',
  incorrectURLError:
    'URL format is incorrect. Please make sure you are using a HTTPS extension',
  requiredEndpointUrlError: 'Enter Endpoint URL',
  requiredEndpointUsername: 'Enter Username',
  requiredEndpointPassword: 'Enter Password',

  requiredApiKeyError: 'Enter API Key',
  maxCharLengthError: "You've exceeded the maximum character length of 64",
  invalidApiKeyError:
    'Invalid API key format. Enter key that contains both letters and numbers',
  furtherAssistance: 'If you require further assistance, ',
  ntisTechnicalAuthority: 'email NTIS Technical Authority',
  ntisTechnicalAuthorityUrl:
    'https://www.trafficengland.com/resources/cms-docs/aup.pdf',
};
